import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: 'Safe for kids?',
  a: 'Yes. All remedies include kid dosing (½ adult). Red flags for under 2yo are clearly marked.'
}, {
  q: 'What if allergic?',
  a: '200+ remedies = options. Each has contraindications listed so you can find safe alternatives.'
}, {
  q: 'Grocery store ingredients?',
  a: '95% available at Walmart/Whole Foods. 5% specialty (Amazon links provided in Resources).'
}, {
  q: 'Doctors approve?',
  a: 'Complementary, not replacement. When to call a doctor is clearly stated for safety.'
}, {
  q: 'Refund policy?',
  a: '30-day money back. Try recipes—if no relief, full refund. No questions asked.'
}, {
  q: 'Time commitment?',
  a: '15–30 min prep. Symptom Matrix = 60 seconds to find your remedy.'
}, {
  q: 'Digital download?',
  a: 'Instant PDF access. You can also print the Symptom Matrix card for your wallet.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-[#faf8f0]" data-id="element-11">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1a3c2a] text-center mb-12" data-id="element-13">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-14">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden border border-[#1a3c2a]/10" data-id="element-15">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors" data-id="element-16">
                <span className="font-bold text-[#1a3c2a] text-lg" data-id="element-17">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="text-[#c9a84c]" data-id="element-18" /> : <ChevronDown className="text-[#c9a84c]" data-id="element-19" />}
              </button>
              <AnimatePresence data-id="element-20">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-21">
                    <div className="px-6 pb-6 text-[#5c4a32]" data-id="element-22">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}